module.exports = __webpack_public_path__ + "static/media/img_flow1@2x.5ccfc8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_flow1@2x.png
// module id = 904
// module chunks = 0